// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getDomainListFailed, getDomainListRequested, getDomainListSucceeded } from './select-domain.actions';
import { SelectDomainService } from '@par/app/shared/select-domain/services/select-domain.service';

@Injectable()
export class SelectDomainEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getDomainListRequested),
      mergeMap(() => this.service.getDomainList()
        .pipe(
          map((response) => getDomainListSucceeded({response})),
          catchError(() => of(getDomainListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: SelectDomainService,
  ) {
  }
}
